import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Sintija
 * id 87E942A2-9A34-4EF0-9025-63CA97919465
 * name format-line-height
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-line-height.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatLineHeightIcon = createSvgIcon(<><path d="M21 22H3V20H21V22M21 4H3V2H21V4M10 13.7H14L12 8.3L10 13.7M11.2 6H12.9L17.6 18H15.6L14.7 15.4H9.4L8.5 18H6.5L11.2 6Z" /></>, 'FormatLineHeightIcon');
export default FormatLineHeightIcon